import React from 'react';

import './Logo.css';

function Logo() {
    return (
        <a href="/" className="logo-container">
            <div className="logo"></div>
        </a>
    )
}

export default Logo;